<template>
    <b-card no-body class="h-100">
        <div class="p-1 d-flex align-items-center border-bottom">
            <h4 class="mb-0">Arabuluculuk</h4>
            <button class="btn btn-sm btn-outline-primary ml-auto" v-on:click="goToMediation">
                Ekrana Git
            </button>
        </div>

        <b-overlay :show="getting" opacity="0.5">
            <div class="p-1">
                <!-- Anlaşma durumu -->
                <div class="row text-center gy-1">
                    <div class="col-4">
                        <h3 class="mb-25 text-warning">{{ data.AnlasmaBekleyen }}</h3>
                        <small class="text-muted">Anlaşma Bekleyen</small>
                    </div>
                    <div class="col-4">
                        <h3 class="mb-25 text-success">{{ data.AnlasmaSaglanan }}</h3>
                        <small class="text-muted">Anlaşma Sağlanan</small>
                    </div>
                    <div class="col-4">
                        <h3 class="mb-25 text-danger">{{ data.AnlasmaSaglanmayan }}</h3>
                        <small class="text-muted">Sağlanamayan</small>
                    </div>
                </div>

                <hr class="my-1" />

                <!-- Ödeme durumu -->
                <div class="row text-center gy-1">
                    <div class="col-6">
                        <h4 class="mb-25 text-danger">{{ data.OdemeBekleyen }}</h4>
                        <small class="text-muted">Ödeme Bekleyen</small>
                    </div>
                    <div class="col-6">
                        <h4 class="mb-25 text-info">{{ data.OdemeBaslayan }}</h4>
                        <small class="text-muted">Ödemesi Başlayan</small>
                    </div>
                </div>

                <hr class="my-1" />

                <ul class="list-group list-group-flush">
                    <li class="list-group-item d-flex align-items-center px-0 py-50">
                        <span class="text-muted">Toplam Ödenen</span>
                        <strong class="ml-auto">{{ data.ToplamOdenenTutarStr }}</strong>
                    </li>
                    <li class="list-group-item d-flex align-items-center px-0 py-50"
                        v-if="data.GonderilmeyenOdemeAdedi > 0">
                        <span class="text-muted">
                            Bankaya Gönderilmemiş
                            <span class="badge badge-light-warning ml-25">{{ data.GonderilmeyenOdemeAdedi }}</span>
                        </span>
                        <strong class="ml-auto text-warning">{{ data.GonderilmeyenOdemeTutariStr }}</strong>
                    </li>
                </ul>

                <div class="text-center text-muted mt-1" v-if="data.ToplamArabuluculuk == 0">
                    <small>Arabuluculuk süreci olan çıkış bulunmuyor.</small>
                </div>
            </div>
        </b-overlay>
    </b-card>
</template>

<script>
import { BCard, BOverlay } from "bootstrap-vue";
import EmployeeOperationsApi from "@/api/employee-operations";

export default {
    components: { BCard, BOverlay },
    data() {
        return {
            getting: false,
            data: {
                ToplamArabuluculuk: 0,
                AnlasmaBekleyen: 0,
                AnlasmaSaglanan: 0,
                AnlasmaSaglanmayan: 0,
                OdemeBekleyen: 0,
                OdemeBaslayan: 0,
                ToplamOdenenTutar: 0,
                ToplamOdenenTutarStr: "0,00",
                GonderilmeyenOdemeAdedi: 0,
                GonderilmeyenOdemeTutari: 0,
                GonderilmeyenOdemeTutariStr: "0,00",
            },
        };
    },
    mounted() {
        this.get();
    },
    methods: {
        async get() {
            this.getting = true;
            try {
                const res = await EmployeeOperationsApi.MediationDashboard();
                if (res?.data?.Success && res.data.Data) this.data = res.data.Data;
            } finally {
                this.getting = false;
            }
        },
        goToMediation() {
            this.$router.push({ name: "mediation" });
        },
    },
};
</script>
